<template>
  <GrupoLeyendaCheck
    titulo="Áreas de estudio"
    checkboxType="normal"
    v-model="areas_expanded"
  >
    <!-- <BotonQuitarTodos @click="quitarTodos" v-width-control="'30%'" /> -->
    <span v-width-control="'40%'"></span>
    <BotonMasInfo @click="masInfo" v-width-control="'45%'" />
    <DaiLeyendaMapa
      :para="[
        'areas_region_nororiental',
        'areas_subcuenca',
        'areas_zona_pelt',
        'areas_zona_federal_lago_texcoco',
        'areas_obra_principal_naim',
        
      ]"
      class="l-areas-estudio"
    />
  </GrupoLeyendaCheck>
</template>

<script>
import GrupoLeyendaCheck from "./utils/GrupoLeyendaCheck.vue";
import BotonMasInfo from "./utils/BotonMasInfo.vue";
// import BotonQuitarTodos from "./utils/BotonQuitarTodos.vue";
import { scrollTo } from "@/components/_utils.js";

export default {
  computed: {
    areas_expanded: {
      get() {
        return this.$store.state.mapa.temasExpandidos.areas;
      },
      set(expandido) {
        this.$store.commit("mapa/setTemasExpandidos", {
          tema: "areas",
          expandido: expandido,
        });
      },
    },
  },
  methods: {
    quitarTodos() {
      console.log("apagar todas las capas de areas");
    },
    masInfo() {
      this.$store.commit("mapa/setFichaActiva", "areas");
      scrollTo(document.querySelector("[data-section='fichas']"),-102);
    },
  },
  components: {
    GrupoLeyendaCheck,
    // BotonQuitarTodos,
    BotonMasInfo,
  },
};
</script>

<style lang="scss">
.l-areas-estudio {
  .dai-map-shape > div {
    border-radius: 20%;
  }
  [data-layer="areas_region_nororiental"],
  [data-layer="areas_subcuenca"] {
    .dai-map-shape > div {
      border-style: dashed;
    }
  }
  [data-layer="areas_zona_pelt"]{
    .dai-map-shape > div {
      border-style: dotted;
    }
  }
}
</style>